(function(){'use strict';
  document.querySelectorAll('.accordion__btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var p=btn.nextElementSibling,open=btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded',String(!open));
      p.style.maxHeight=open?null:p.scrollHeight+'px';
    });
  });
  var modal=document.getElementById('SizeChartModal');
  function close(){if(modal){modal.classList.remove('is-open');document.body.style.overflow='';}}
  document.querySelectorAll('[data-open-sizechart]').forEach(function(el){
    el.addEventListener('click',function(e){e.preventDefault();if(modal){modal.classList.add('is-open');document.body.style.overflow='hidden';}});
  });
  if(modal){modal.querySelectorAll('[data-close-modal]').forEach(function(el){el.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});}

  var stage=document.querySelector('[data-gallery-stage]');
  if(stage){
    var medias=stage.querySelectorAll('.gallery__media'),thumbs=document.querySelectorAll('.gallery__thumb');
    function show(id){
      medias.forEach(function(m){var match=m.getAttribute('data-media-id')===String(id);m.hidden=!match;var v=m.querySelector('video');if(v&&!match)v.pause();});
      thumbs.forEach(function(t){t.setAttribute('aria-current',String(t.getAttribute('data-media-id')===String(id)));});
    }
    thumbs.forEach(function(t){t.addEventListener('click',function(){show(t.getAttribute('data-media-id'));});});
  }

  var form=document.querySelector('[data-product-form]');
  if(!form)return;
  var dataEl=document.querySelector('[data-variants-json]');if(!dataEl)return;
  var variants;try{variants=JSON.parse(dataEl.textContent);}catch(e){return;}
  var optionCount=parseInt(form.getAttribute('data-option-count'),10)||1;
  var idInput=form.querySelector('[name="id"]');
  var initVar=variants.find(function(v){return String(v.id)===String(idInput.value);})||variants[0];
  var selected=initVar?initVar.options.slice():[];
  var priceEl=document.querySelector('[data-price]'),compareEl=document.querySelector('[data-compare]');
  var addBtn=form.querySelector('[data-add-btn]'),stockEl=document.querySelector('[data-stock]');
  var low=parseInt(form.getAttribute('data-low-threshold'),10)||10;

  function find(){return variants.find(function(v){for(var i=0;i<optionCount;i++){if(v.options[i]!==selected[i])return false;}return true;});}
  function state(){
    for(var i=0;i<optionCount;i++){var lbl=document.querySelector('[data-selected-'+i+']');if(lbl)lbl.textContent=selected[i];}
    document.querySelectorAll('.variant__pill').forEach(function(pill){
      var idx=parseInt(pill.getAttribute('data-option-index'),10),val=pill.getAttribute('data-value');
      pill.setAttribute('aria-pressed',String(selected[idx]===val));
      var any=variants.some(function(v){return v.options[idx]===val&&v.available;});
      pill.classList.toggle('is-soldout',!any);
    });
  }
  function render(){
    var v=find();state();
    if(!v){addBtn.disabled=true;addBtn.textContent='Non disponibile';if(stockEl)stockEl.textContent='';return;}
    idInput.value=v.id;
    if(priceEl)priceEl.textContent=v.price_formatted;
    if(compareEl){if(v.compare_at_price&&v.compare_at_price>v.price){compareEl.textContent=v.compare_at_formatted;compareEl.style.display='';if(priceEl)priceEl.classList.add('sale');}else{compareEl.style.display='none';if(priceEl)priceEl.classList.remove('sale');}}
    if(v.available){addBtn.disabled=false;addBtn.textContent='Aggiungi al carrello';}else{addBtn.disabled=true;addBtn.textContent='Esaurito';}
    if(stockEl){if(v.available&&v.inventory_management&&v.inventory_quantity>0&&v.inventory_quantity<=low){stockEl.textContent='Solo '+v.inventory_quantity+' pezzi disponibili!';}else{stockEl.textContent='';}}
    if(v.featured_media_id&&stage){var t=document.querySelector('.gallery__thumb[data-media-id="'+v.featured_media_id+'"]');if(t)t.click();}
  }
  document.querySelectorAll('.variant__pill').forEach(function(pill){
    pill.addEventListener('click',function(){selected[parseInt(pill.getAttribute('data-option-index'),10)]=pill.getAttribute('data-value');render();});
  });
  render();
})();
